export let SenderDomain;
(function (_SenderDomain) {
  let VerificationFlowVersion = /*#__PURE__*/function (VerificationFlowVersion) {
    VerificationFlowVersion["V1"] = "v1";
    VerificationFlowVersion["V2"] = "v2";
    VerificationFlowVersion["V3"] = "v3";
    VerificationFlowVersion["PREZLYMAIL"] = "prezlymail";
    return VerificationFlowVersion;
  }({});
  _SenderDomain.VerificationFlowVersion = VerificationFlowVersion;
})(SenderDomain || (SenderDomain = {}));